<script setup lang="ts">
import { onBeforeUnmount, ref, watch } from 'vue'
import { mentorshipApi } from '../services/mentorshipApi'
import type { MentorshipLinkOption } from '../types'
import { getApiError } from '@/composables/getApiError'

const props = defineProps<{ modelValue: number | string | null
  caseId: string
  kind: 'task' | 'meeting'
  label: string }>()
const emit = defineEmits<{ 'update:modelValue': [value: number | string | null] }>()
const items = ref<MentorshipLinkOption[]>([])
const search = ref('')
const loading = ref(false)
const error = ref('')
let sequence = 0
let timer: ReturnType<typeof setTimeout> | undefined
async function load() {
  const current = ++sequence
  loading.value = true
  error.value = ''
  try {
    const result = await mentorshipApi.getLinkOptions(props.caseId, props.kind, search.value || '')
    if (current !== sequence) return
    const selected = items.value.find(item => item.id === props.modelValue)
    items.value = result
    if (selected && !result.some(item => item.id === selected.id)) items.value.unshift(selected)
  } catch (e) {
    if (current === sequence) error.value = getApiError(e, 'Не удалось загрузить доступные записи')
  } finally {
    if (current === sequence) loading.value = false
  }
}
watch(search, () => {
  clearTimeout(timer)
  timer = setTimeout(load, 300)
})
watch(() => [props.caseId, props.kind], load, { immediate: true })
onBeforeUnmount(() => {
  ++sequence
  clearTimeout(timer)
})
</script>

<template>
  <VAutocomplete
    v-model:search="search"
    :model-value="modelValue"
    :items="items"
    item-title="label"
    item-value="id"
    :label="label"
    :loading="loading"
    :error-messages="error"
    no-filter
    clearable
    no-data-text="Доступных записей не найдено. Уточните поиск."
    @update:model-value="emit('update:modelValue', $event)"
  />
</template>
